export class HttpError extends Error {
  status: number | undefined | null

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(err: any) {
    super(createErrorMessage(err))
    this.name = 'HttpError'
    // These propeties are using in filterAndNotify for bugsnag
    this.status = err?.status
  }
}

function createErrorMessage(
  err:
    | {
        status: number | undefined
        response?: {
          json?: unknown
        }
      }
    | undefined
): string {
  const status = err?.status
  const responseBody = err?.response?.json

  if (status === undefined && responseBody === undefined) return `Unexpected HTTP error`
  if (responseBody === undefined) return `Unexpected HTTP error: ${status}`
  return `Unexpected HTTP error: ${status} - ${JSON.stringify(responseBody)}`
}
